<template>
  <div class="medialib">
    <h2 class="large-title medialib__title">Media Library</h2>
    <adx-media 
      ref="media"
      :display="display"
    />
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Media from '@/views/Media'

export default {
  name: 'adx-media-library',
  components: {
    'adx-modal': Modal,
    'adx-media': Media
  },
  props: {
    
  },
  data() {
    return {
      display: 'grid',
      modalUpload: false,
    }
  },
  computed: {

  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.filter-dropdown, .sorting-dropdown {
  .btn-regular {
    padding: 8px;
  }
}
</style>

